import React from 'react';
import useTrafficStyles from '../styles/trafficStyles';
import {
    Box,
    Container,
    Grid,
    Typography,
} from "@material-ui/core";
import theme from '../styles/theme';
import _ from 'lodash';
import ClearIcon from '@material-ui/icons/Clear';
import CheckIcon from '@material-ui/icons/Check';

const RowChanges = ({rowData, defaultValues, currentValues}) => {
    const {title, arr} = rowData;
    const trafficClasses = useTrafficStyles();

    return (
        <Container maxWidth={false} disableGutters className={trafficClasses.rowDiff}>
            {title && (
                <Box className={trafficClasses.rowDiffSectionHeader}>
                    <Typography variant="body1">
                        <strong>{title}</strong>
                    </Typography>
                </Box>
            )}

            <Box>
                {arr.map(item => {
                    const {key, label, type} = item;
                    const newInputKey = currentValues[key];
                    const currentInputKey = defaultValues ? defaultValues[key] : '';
                    return (
                        <Grid container key={key}
                              className={`row - grid ${newInputKey !== currentInputKey ? trafficClasses.rowDiffHighlight : ''}`}>
                            {label ? (
                                <Grid item xs={4}>
                                    <Typography variant="body">
                                        {label}
                                    </Typography>
                                </Grid>
                            ) : null}
                            <Grid item xs={4}>
                                {type === 'switch' ? (
                                    <>
                                        {currentInputKey ? (
                                            <CheckIcon style={{color: theme.palette.success.main}}/>
                                        ) : (
                                            <ClearIcon style={{color: theme.palette.error.main}}/>
                                        )}
                                    </>
                                ) : (
                                    <span>{_.isNil(currentInputKey) || currentInputKey === '' ? 'N/A' : currentInputKey}</span>
                                )}
                            </Grid>
                            <Grid item xs={4} style={{ 'overflow-wrap':' break-word' }}>
                                {type === 'switch' ? (
                                    <>
                                        {newInputKey ? (
                                            <CheckIcon style={{color: theme.palette.success.main}}/>
                                        ) : (
                                            <ClearIcon style={{color: theme.palette.error.main}}/>
                                        )}
                                    </>
                                ) : (
                                    <span>{_.isNil(newInputKey) || newInputKey === '' ? 'N/A' : newInputKey}</span>
                                )}
                            </Grid>
                        </Grid>
                    );
                })}
            </Box>
        </Container>
    );
};

export default RowChanges;